export default function Pandas_Syllabus() {
  return <div>Pandas_Syllabus</div>;
}
